import { useEffect } from 'react';
import { connect } from 'react-redux';

import { fireApsAds } from 'helpers/apsAdvertisement';
import GamSlot from 'components/common/GamSlot';
import AdsenseSlot from 'components/common/AdsenseSlot';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { HYDRA_6PM_ADSENSE_LP_HF } from 'constants/hydraTests';
import { isAssigned } from 'actions/ab';

import css from 'styles/components/landing/ad.scss';

const TYPE_DISPLAY = 'display';
const TYPE_TEXT = 'text';

// Component for interfacing a Symphony component with AdsenseSlot & GamSlot
export const Ad = ({ slotName, slotIndex, slotDetails, gamSlots, hydra6pmAdsenseLpHf }) => {
  const { name, styleId, query, type, gamslot } = slotDetails;

  /*
    This is an array that is shaped like:
    [ {name: 'HOME-NARROW-MID', device: 'mobile', height: '50', width: '320' } ]
    Could potentially be just [ { name: 'HOME-NARROW-MID' } ]
    if we have preset sizing and devices in helpers/apsAdvertisement.js
  */
  const gamSlotsList = gamslot || gamSlots;

  useEffect(() => {
    if (hydra6pmAdsenseLpHf && type === TYPE_DISPLAY) {
      fireApsAds({ slotsDetailed: gamSlotsList });
    }
  }, [gamSlotsList, hydra6pmAdsenseLpHf, type]);

  if (!hydra6pmAdsenseLpHf) {
    return null;
  }

  if (type === TYPE_TEXT) {
    return (
      <AdsenseSlot
        className={css.container}
        name={name}
        styleId={styleId}
        query={query}
        forceShow={true}
        slotName={slotName}
        slotIndex={slotIndex}
      />
    );
  } else if (type === TYPE_DISPLAY) {
    return (
      <>
        {gamSlotsList?.map(({ name, device }) =>
          <GamSlot
            key={name}
            slot={name}
            deviceOverride={device}
            className={css.container}
            forceShow={true}
            slotName={slotName}
            slotIndex={slotIndex}
          />
        )}
      </>
    );
  }

  return null;

};

const mapStateToProps = state => ({
  hydra6pmAdsenseLpHf: isAssigned(HYDRA_6PM_ADSENSE_LP_HF, 1, state)
});

const ConnectedAd = connect(mapStateToProps)(Ad);
export default withErrorBoundary('Ad', ConnectedAd);
